export default {
  pending: [],
  pendingPagination: {
    totalPages: 0,
    totalItems: 0
  },
  requests: [],
  requestsPagination: {
    totalPages: 0,
    totalItems: 0
  },
  currentRequest: null,
  notifications: [],
  unreadCount: 0,
  loading: false
}
